import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import TopBar from './TopBar';
import Footer from './Footer';
import Sidebar from './Sidebar';
//import CourseSidebar from './CourseSidebar';
//import LPathSidebar from './LPathSiderbar';
//import ContentSidebar from './ContentSidebar';
//import UserSidebar from './UserSidebar';
//import SettingsSidebar from './SettingsSidebar';
//import CertificateSidebar from './CertificateSidebar';
//import ReportsSidebar from './ReportsSidebar';
import { Box, Container } from '@mui/material';
import { tokens } from '../../theme';
import './Layout.css';
import ContentPlayerModalContainer from '../Player/ContentPlayerModalContainer';
import { getTrialStatus, isLeavingForSignIn } from '../../services/api';
import TrialExpiredModal from './TrialExpiredModal';
import LoadingSkeleton from '../common/LoadingSkeleton'
import { useToast } from '../../context/ToastContext';
const getActiveMenu = (path) => {
    if (path.includes('dashboard')) return 'home';
    if (path.includes('users')) return 'manage_user';
    if (path.includes('courses')) return 'manage_courses';
    if (path.includes('learning_path')) return 'manage_learning_paths';
    if (path.includes('contents/form')) return 'create_content';
    if (path.includes('contents')) return 'manage_content';
    //if (path.includes('assignments/form')) return 'create_assignment';
    //if (path.includes('assignments')) return 'manage_assignment';
    //if (path.includes('questions/form')) return 'create_question';
    //if (path.includes('questions')) return 'manage_questions';
    if (path.includes('notifications')) return 'notifications';
    if (path.includes('catlog')) return 'catlog';
    //if(path.includes ('job-aids')) return 'manage_job_aids';
    //if(path.includes ('job-aids/create')) return 'create_job_aids';
    return 'home';    
};

const Layout = () => {
    const { user, loading } = useUser();
    const [activeMenu, setActiveMenu] = useState('home');
    const location = useLocation();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    /*    
    const isCourseRoute = (location.pathname.includes('/course/') || 
        location.pathname.includes('/settings/feedback-settings/') || 
        location.pathname.includes('settings/email-template/')) && 
        !location.pathname.includes('learner/course');

    const isLPathRoute = location.pathname.includes('/learning_path/') ||
        location.pathname.includes('settings/lp-email-template/');

    const isCertificateRoute = location.pathname.includes('/certificates/');
    const isReportsRoute = location.pathname.includes('/reports/');

    const isUserManagementPath =         
        (location.pathname.startsWith('/users') || 
        location.pathname.startsWith('/groups') || 
        location.pathname.startsWith('/active-fields') ||
        location.pathname.startsWith('/job-roles')) && 
        !location.pathname.includes('/users/profile');
    
    const isContentRoute = (
        location.pathname.includes('/contents') ||
        location.pathname.includes('/assignments') ||
        location.pathname.includes('/quiz') ||
        location.pathname.includes('/questions') 
        // location.pathname.includes('/job-aids') ||
        // location.pathname.includes('/certificates') 
        ) &&
        (
        !location.pathname.includes('/assignments/submissions') &&
        !location.pathname.includes('/quiz/submissions') &&
        !location.pathname.includes('/assignments/assignment_rank') &&  
        !location.pathname.includes('/quiz/quiz_rank')
        );

    const isSettingsRoute = 
    location.pathname.includes('/settings/generalSettings') ||
    location.pathname.includes('/settings/feedback') || 
    location.pathname.includes('/settings/emailSettings') ||
    location.pathname.includes('/settings/embedded')
    */
    useEffect(() => {
        const path = location.pathname;
        setActiveMenu(getActiveMenu(path));
    }, [location]);

    // S-4 pt 5.2: a file address the person can't have brings them here with the notice 'This file isn't available.'
    // (no link). The server leaves a short-lived 'beetsol_notice=file-unavailable' cookie, read once and cleared here.
    const { showToast } = useToast();
    useEffect(() => {
        if (/(?:^|;\s*)beetsol_notice=file-unavailable(?:;|$)/.test(document.cookie)) {
            document.cookie = 'beetsol_notice=; Max-Age=0; path=/';
            showToast("This file isn't available.", 'info');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [trialExpired, setTrialExpired] = useState(false);

    useEffect(() => {
        getTrialStatus().then(res => {
            if (res.data.expired) setTrialExpired(true);
        });
    }, []);

    if (loading) {
        return <LoadingSkeleton rows={5} />;
    }

    // While a 401 is already loading the sign-in page (services/api.js), wait for it rather than show the sign-in page here
    // first, which would use up its once-only notice (S-6.1 pt 5.2, PR #8). Removed 23 Oct 2026 (S-6.1 pt 5.2, PR #8):
    // moving to the sign-in page whenever the user is gone, that load or not.
    if (!user) {
       return isLeavingForSignIn() ? <LoadingSkeleton rows={5} /> : <Navigate to="/login" />;
    }
    
    const renderSidebar = () => (
        <Sidebar
            open={sidebarOpen}
            onClose={() => setSidebarOpen(false)}
            user={user}
            activeMenu={activeMenu}
        />
    );

    return (
        <Box sx={{ 
            display: 'flex', 
            //flexDirection: 'column', 
            minHeight: '100vh',
            overflow: 'hidden' // Prevent scrolling on the outer container
        }}>
            
            {/* Sidebar with appropriate positioning */}
            {renderSidebar()}
            <Box sx={{ 

                display: 'flex', 
                flexGrow: 1,
                flexDirection: 'column',
                minHeight: '100vh',
                //mt: '84px', // Add margin-top equal to the height of your TopBar (usually 84px for MUI)
                ///height: 'calc(100vh - 84px)',
                overflow: 'hidden'
            }}>
                 {/* TopBar only in content area */}
                <TopBar
                    onMenuClick={() => setSidebarOpen(!sidebarOpen)}
                />
                
                {/* Scrollable main content */}               
                <Box 
                    component="main" 
                    sx={(theme) => ({ 
                        flexGrow: 1,
                        overflowY: 'auto',
                    overflowX: 'hidden',
                    px: { xs: 3, sm: 4, md: 6 },
                    // Phone width only: the page starts below the top bar, which has a background there (K21.2 pt 30).
                    // From sm up the CSS margin stays as it was.
                    [theme.breakpoints.down('sm')]: { marginTop: tokens.topnav.height }
                })}
                className={`main-content ${
                    sidebarOpen ? 'sidebar-open' : ''
                }`}
            >
            <Container 
                        maxWidth="xl"
                        sx={{ 
                            // flexGrow: 1, 
                            display: 'flex', 
                            flexDirection: 'column',
                            minHeight: '100%'
                            // mb: 3,
                            // mx: 'auto',
                            // width: '100%'
                        }}
                    >
                        <Outlet />
                
                    <Footer sx={{ mt: 'auto' }} />
                </Container>
                </Box>
            </Box>
            <ContentPlayerModalContainer />
            {trialExpired && (
                <TrialExpiredModal open={true} />
            )}
        </Box>
    );
};
export default Layout;